import api from '@/plugins/api'
import { inspection, inspectionManual as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'

const store = 'inspectionManual'

export default {
  state: () => ({
    dependencyInspectionManual: [],

    inspectionManual: {},
    certificateManual: {},


    inspectionManualEmissionInspection: [],
    inspectionManualVehicleConsumption: [],
    inspectionManualNoiseInspection: [],
  }),
  getters: {
    characteristicDependency: state => fieldName => {
      return state.dependencyInspectionManual.find(item => item.field_name === fieldName)
    }
  },
  actions: {
    async getEmissionInspection (context, id) {
      const response = await api.get(`${ endpoint.emissionInspection(id)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManualEmissionInspection', data: response.data })
        return response.data
      } return false
    },

    async addEmissionInspection (context, data) {
      const response = await api.post( endpoint.emissionInspection(data.id), {body: data.body})
      if (await requestValidation(response)) {
        return response.data
      }
      return false
    },

    // =======================================================

    async getNoiseInspection (context, id) {
      const response = await api.get(`${ endpoint.noiseInspection(id)}`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManualNoiseInspection', data: response.data })
        return response.data
      } return false
    },

    async addNoiseInspection (context, data) {
      const response = await api.post( endpoint.noiseInspection(data.id), {body: data.body})

      if (await requestValidation(response)) {
        return response.data
      }

      return response
    },
    // =======================================================

    async getVehicleConsumption (context, id) {
      const response = await api.get(`${ endpoint.vehicleConsumption(id)}`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManualVehicleConsumption', data: response.data })
        return response.data
      } return false
    },

    async addVehicleConsumption (context, data) {
      const response = await api.post( endpoint.vehicleConsumption(data.id), {body: data.body})

      if (await requestValidation(response)) {
        return response.data
      }
      return response
    },

    // =======================================================

    async getDependencyManual (context, id) {
      const response = await api.get(endpoint.dependency(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', {store, state: 'dependencyInspectionManual', data: response.data})
      }
    },

    async getInspectionManual (context, id) {
      const response = await api.get(`${ endpoint.inspectionManual(id)}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManual', data: response.data })
        return response.data
      } return false
    },

    async createInspectionManual (context, data) {
      const response = await api.post(`${ endpoint.inspectionManual()}`, { body: data })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManual', data: response.data })
        return response.data
      } return false
    },

    async updateInspectionManual (context, data) {
      const response = await api.patch(`${ endpoint.inspectionManual(data.id)}`, { body: data.body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionManual', data: response.data })
        return response.data
      }
      return false
    },

    async getCertificateManual (context, id) {
      const response = await api.get(`${ inspection.certificate }?manual_inspection=${id}`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', {
          store,
          state: 'certificateManual',
          data: response.data.results[0] === undefined ? {} : response.data.results[0]
        })
        return response.data
      }
      return isResult
    },

    async updateCertificateManual (context, data) {
      const response = await api.patch(inspection.updateCertificate(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getCertificateManual', data.inspectionID)
      return isResult
    },

    async setCertificateManualSign (context, data) {
      const response = await api.post(inspection.certificateSign, { body: { document: data.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        const responseAppendix = await api.post(inspection.certificateAppendixSign, { body: { document: data.appendixID }})
        const isResultAppendix = await requestValidation(responseAppendix)
        //because celery give data
        if (isResultAppendix) {
          setTimeout(async () => {
            await context.dispatch('getCertificateManual', data.inspectionID)
            await context.dispatch('getInspectionManual', data.statementID)
          }, 700)
        }
      }
      return isResult
    }

  }
}